// Mint-Settings-Phone · dữ liệu mẫu theo script board (chưa ghi DB).
export const PH_CH = ['Push', 'Zalo', 'Email'] as const;
export type PhNoti = { id: string; k: string; s: string; def: readonly [number, number, number]; locked?: boolean };
export const PH_NOTI: readonly PhNoti[] = [
  { id: 'p0', k: 'Khẩn P0', s: 'K1–K5, sự cố xe, cont lạnh', def: [1, 1, 0], locked: true },
  { id: 'task', k: 'Việc tới hạn & quá hạn', s: 'Của tôi và người tôi đang thay', def: [1, 0, 1] },
  { id: 'appr', k: 'Duyệt chờ tôi', s: 'Release, margin, thanh toán, nghỉ phép', def: [1, 1, 1] },
  { id: 'mail', k: 'Mail gắn PIC cho tôi', s: 'info@ · support@', def: [1, 0, 0] },
  { id: 'vsl', k: 'Tàu đổi lịch / cut-off', s: 'Job tôi phụ trách', def: [1, 1, 0] },
  { id: 'debt', k: 'Công nợ quá hạn', s: 'Khách tôi phụ trách', def: [0, 0, 1] },
  { id: 'digest', k: 'Tóm tắt đầu ngày Ask HANA', s: '07:30 ngày làm việc', def: [1, 0, 1] },
];
export const PH_BACKUP: readonly (readonly [string, string, readonly string[]])[] = [
  ['SALE-MGR', 'TUANNT', ['TUANNT', 'ANDG', 'PHILIP']],
  ['BOD-DDIR', 'PHILIP', ['PHILIP']],
  ['Khách của tôi', 'ANDG', ['ANDG', 'TUANNT']],
];
export const PH_DELEG0: readonly (readonly [string, string])[] = [
  ['BOD-DDIR → PHILIP', '24–25/Oct/2026 · nghỉ phép'],
  ['TUANNT → DAVID · 6 khách', '22–23/Oct/2026 · TUANNT vắng'],
];
export const PH_SESSIONS: readonly (readonly [string, string, boolean])[] = [
  ['iPhone 15 · HANA Ezy', 'Máy này · thiết bị chấm công', true],
  ['Windows · Chrome 131', '235 Cộng Hòa · hôm nay 08:02', false],
  ['iPad Air · HANA Ezy', 'TP.HCM · hôm qua', false],
  ['MacBook · Edge', 'Hà Nội · 6 ngày trước', false],
];
export const PH_SEATS = [['SALE-MGR', 'pri'], ['BOD-DDIR · quyền', 'warn'], ['ADMIN', 'mute']] as const;
export const PH_SEAT_ROWS: readonly (readonly [string, string])[] = [
  ['SALE-MGR · Trưởng phòng KD', 'Chính · từ 26/Jul/2026'], ['BOD-DDIR · Phó Giám đốc', 'Quyền (Acting) · từ 01/Oct/2026'], ['ADMIN', 'Cờ kỹ thuật'],
];

export type PhReq = { id: string; k: string; a: string; b: string; by: string; why: string; when: string; st: 'pend' | 'done' | 'rej' | 'undone'; mine: boolean; self?: boolean; selfDone?: boolean; flag?: string };
export const PH_QUEUE: readonly PhReq[] = [
  { id: 'CR-2610-088', k: 'Sàn margin (margin_floor_pct)', a: '8 %', b: '7 %', by: 'HANHLTM · ACC-CP', why: 'Hạ sàn tuyến Nhật Q4 theo chỉ đạo BOD', when: '23/Oct 07:58', st: 'pend', mine: true, flag: 'ACC-CA trống → leo lên [BOD-DIR] PHILIP' },
  { id: 'CR-2610-087', k: 'Cấp quyền cột COL_COST cho TUANNT', a: 'Ẩn', b: 'Xem', by: 'DAVID · ADMIN', why: 'TUANNT làm báo giá dự án cần xem cost', when: '22/Oct 17:20', st: 'pend', mine: true, self: true, flag: 'Phiếu của chính anh · duyệt bằng ghế BOD-DDIR sẽ ghi cờ "Tự duyệt"' },
  { id: 'CR-2610-086', k: 'Nhập customer.csv · 240 dòng', a: '1.812 khách', b: '2.052 khách', by: 'ANDG · SALE-SE', why: 'Danh sách khách từ hội chợ VIFFAS', when: '22/Oct 15:05', st: 'pend', mine: true },
  { id: 'CR-2610-081', k: 'Ma trận duyệt · thanh toán đối tác cấp 1', a: '≤ 20.000.000', b: '≤ 30.000.000', by: 'HANHLTM · ACC-CP', why: 'Giảm tải BOD cho cước nội địa', when: '19/Oct 09:40', st: 'done', mine: false },
  { id: 'CR-2610-079', k: 'Xoá 12 booking nháp quá 60 ngày', a: '12 dòng', b: '0', by: 'PHONGNT · OPS-MGR', why: 'Dọn nháp', when: '17/Oct 16:02', st: 'rej', mine: false },
];
export const PH_QUICK = ['Thiếu chứng từ kèm theo', 'Cần BOD xem trước', 'Sai giá trị, sửa lại'] as const;

export function phNotiOn(n: PhNoti, ci: number, ov: Readonly<Record<string, boolean>>): boolean {
  if (n.locked && n.def[ci] === 1) return true;
  return ov[n.id + ci] ?? n.def[ci] === 1;
}
export function phNotiSum(n: PhNoti, ov: Readonly<Record<string, boolean>>): string {
  const on = PH_CH.filter((_, ci) => phNotiOn(n, ci, ov));
  return on.length ? on.join(' · ') : 'Tắt';
}
